import {motion} from "framer-motion";
import styles from './Footer.module.css';

export default function Footer() {
    return (
        <footer className={styles.footer}>
            {/* Parallax sushi image w/ overlay */}
            <div className={styles.parallaxImageContainer}>
                <img
                    src="https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/680fd0419402918c800d1b01_pexels-ivan-samkov-8951329.jpg"
                    alt=""
                    className={styles.parallaxImage}
                    draggable={false}
                />
                {/* Black gradient overlay: fade to black from bottom */}
                <div className={styles.overlay}/>
            </div>

            {/* Footer content */}
            <motion.div
                initial={{opacity: 0, y: 36}}
                whileInView={{opacity: 1, y: 0}}
                viewport={{once: true}}
                transition={{duration: 1, ease: [0.23, 1, 0.32, 1]}}
                className={styles.footerContent}
            >
                <div className={styles.grid}>
                    {/* Logo and fine print */}
                    <div className={styles.logoContainer}>
                        <a href="/" className={styles.logoLink}>
                            <img
                                src="/logo.png"
                                alt="Asahi Logo"
                                className={styles.logoImage}
                                draggable={false}
                            />
                        </a>

                    </div>
                    {/* Main */}
                    <div className={styles.section}>
                        <div className={styles.sectionTitle}>
                            Main
                        </div>
                        <a href="/" className={styles.link}>Home</a>
                        <a href="/about" className={styles.link}>About</a>
                        <a href="/menu" className={styles.link}>Menu</a>
                    </div>
                </div>
                {/* Fine print row bottom */}
                <div className={styles.finePrint}>
                    <div>
            <span>
              <a href="/" className={styles.copyrightLink}>Asahi</a> 2025<sup>©</sup>
            </span>
                        {" "}Powered by{" "}
                        <a href="/" target="_blank" className={styles.copyrightLink}>
                            Asahi
                        </a>
                    </div>
                </div>
            </motion.div>
        </footer>
    );
}
